import { Redirect } from "react-router-dom";

export const NewUserRootPage = () => {
    return ( <Redirect to={"/new-user/phone-number"} /> );
}